import React from 'react';
import { Navigate } from 'react-router-dom';
import Home from '../../../pages/Home';

export const homeRoutes = [
  { path: '/', element: <Home /> },
  { path: '/home', element: <Navigate to="/" replace /> },
  { path: '/index.html', element: <Navigate to="/" replace /> }
];
